import React, { Component } from 'react'; 
import {FormControl, Button, Table, InputGroup, Pagination} from 'react-bootstrap';
import _ from 'lodash';
// import Template from './Template';
// import NCReasonsTemplate from './NCReasonsTemplate';
// import ModalWindow from './ModalWindow'

function searchingFor(term){
	return function(x){
		return _.includes(x.templateName.toLowerCase(), term.toLowerCase()) || !term;
	}
}
class IndexAuditForm
 extends Component {
  constructor(props){
    super(props)
    this.state={
      term:'',
      activePage: 1
    }
  
  }
  componentDidMount(){
    this.props.props.function.TokenValidation()     
    this.props.props.function.actionTemplate()        
    this.props.props.function.templateNames() 
  }
  handleChange = (e) => {
    this.setState({term:e.target.value})	
  }
  openTemplate =() => {
    this.props.onCallBack('defaultTemplate')
  }
  openModalEdit = (name) => {
    this.props.onCallBack(name)
  }
  openModalView = (name) =>{
    this.props.onCallBack(name, 'view')
  } 
  handleSelectPagination = (eventKey) => {
    this.setState({
      activePage: eventKey,
    });
	}
	handleSelectPaginationPrev = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage-1,
    });
	}
	handleSelectPaginationNext = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage+1,
    });
  }	


  
  render() {    
    const{templatepayload, accessPermission} = this.props.props
    const{term, activePage} = this.state;
    let templatepayloadFilter=[]
    let permission  = _.includes(accessPermission,'WRITE')  
    const Per_Page=50;
    let totalPages = 1
		const startOffset = (this.state.activePage-1) * Per_Page;
		let startCount = 0;
    let items = [];
    let defaultTemp ;
    if(!_.isEmpty(templatepayload)){
      defaultTemp = templatepayload.filter(obj => obj.templateName === 'Default Template')      
      templatepayloadFilter = templatepayload.filter(obj => obj.templateName !== 'Default Template');   
       totalPages = Math.ceil(templatepayloadFilter.length/Per_Page)	
		for (let number = 1; number <= totalPages; number++) {
			items.push(
        <Pagination.Item key={number} active={number === activePage} 
        onClick={()=>this.handleSelectPagination(number)}>
					{number}
				</Pagination.Item>				
			);
      }
    }
      return(
        <div>
         <span className='alignRight'>         
					  <InputGroup>
				  		<InputGroup.Prepend>
							<InputGroup.Text id="basic-addon1"><i class="fas fa-search"></i></InputGroup.Text>
						</InputGroup.Prepend>
						<FormControl
							placeholder="Search Template Names"
							aria-label="Search"
							aria-describedby="basic-addon1"
							onChange={(e) => this.handleChange(e)}
							value={term}
							/>
					  </InputGroup>
				  </span>
          {!_.isEmpty(defaultTemp) ? 
          <Button onClick={this.openTemplate} className='alignRight buttonwidth' size="md">
            Create Template</Button> : null}      
        	<Table responsive>
					<thead>
							<tr>
								<th>EVALUATION TEMPLATE NAMES</th>
							  {(permission === true) ?	<th>EDIT</th> : null}
                {/* {(permission === true) ?<th>DELETE</th> : null} */}
                <th>VIEW</th>
							</tr>
					</thead>
          <tbody>
          {!_.isEmpty(templatepayloadFilter) ? 
            _.map(templatepayloadFilter.filter(searchingFor(term)), (val, i)=>{
              if(i >= startOffset & startCount < Per_Page){
                startCount++;
              return(
                <tr><td>{val.templateName}</td>
                {(permission === true) ?  <td><i class="fas fa-pen" onClick={() => this.openModalEdit(val.templateName)} /></td> : null}       
                <td><i class='fas fa-eye' onClick={()=>this.openModalView(val.templateName)}/></td>                 
                </tr>	
              )
             } })
            :
            <tr><td colSpan={(permission === true) ? "4" : "2"}>No Record Found</td></tr>

           }
          </tbody>
          </Table>
          {!_.isEmpty(items) ?
          <Pagination>
            <Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
            <Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
            {items[activePage-1]}
            {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
            {items[activePage+1]}
            <Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
            <Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
          </Pagination> : null}
           </div>
      )
    }
  
}

export default IndexAuditForm
;